import * as React from 'react';
import { useEffect } from 'react';

import { useRecommendedPackages } from './hooks';

import { DefaultPublication } from './components/DefaultPublication';
import { RecommendedPackage } from './components/RecommendedPackage';
import { RecommendedPackageHint } from './components/RecommendedPackageHint';

import * as styles from './RecommendedPackages.container.css';
import { Service } from './components/RecommendedPackage/components/Service';
import { ERecommendedPackageGiftType } from '../../../../../../types/reducers/recommendedPackages';

export const RecommendedPackagesContainer = () => {
  const {
    isRender,
    isMobile,
    offerPrice,
    recommendedPackages,
    handleDefaultPublicationClick,
    handleRecommendedPackageClick,
  } = useRecommendedPackages();

  useEffect(() => {
    window.addEventListener('payment-cancel', handleDefaultPublicationClick);

    return () => {
      window.removeEventListener('payment-cancel', handleDefaultPublicationClick);
    };
  }, [handleDefaultPublicationClick]);

  if (!isRender) {
    return null;
  }

  return (
    <>
      <DefaultPublication price={offerPrice} isMobile={isMobile} handleClick={handleDefaultPublicationClick} />

      {recommendedPackages.map(recommendedPackage => {
        const {
          id,
          headerText,
          discountPercent,
          marketingPrice,
          price,
          pricePerOffer,
          tooltipText,
          totalPublicationCount,
          totalAuctionPoints,
          gifts,
        } = recommendedPackage;

        const packageContent = (
          <>
            <Service title="Публикации" count={totalPublicationCount} />
            {gifts.map((gift, index) => {
              if (gift.type === ERecommendedPackageGiftType.Cashback) {
                return;
              }

              const { name, count } = gift;

              return <Service key={index} title={name} count={count} gifted />;
            })}
            <Service title="Баллы" count={totalAuctionPoints} />
          </>
        );

        return (
          <div key={id} className={styles['package-layout']}>
            <RecommendedPackage
              isMobile={isMobile}
              headerText={headerText}
              content={packageContent}
              discountPercent={discountPercent}
              marketingPrice={marketingPrice}
              packagePrice={price}
              pricePerOffer={pricePerOffer}
              handleClick={/* istanbul ignore next */ () => handleRecommendedPackageClick(recommendedPackage)}
            />

            <RecommendedPackageHint isMobile={isMobile} text={tooltipText} />
          </div>
        );
      })}
    </>
  );
};
